export default __webpack_public_path__ + "static/media/email_icon.56924aa6.png";